<ng-container *ngTemplateOutlet="!isSubNav ? tabs : subnav"></ng-container> 
<ng-template #tabs>
  <div [ngClass]="{'tabs-wrapper': withWrapper}">
    <ul class="{{tabNavClasses}}">
      <li *ngFor="let tab of data">
        <a class="tabs-module__tabs" [ngClass]="{'tabs-module__tabs--active': tab.isActive,'disabled': !tab.enabled}"
           (click)="onTabChange(tab.id)" [routerLink]="" queryParamsHandling="preserve">
          <span>{{tab.name}}</span>
        </a>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #subnav>
  <ng-container *ngIf="checkIsSingleTab(); else heading">
    <ul class="sub-nav {{tabSubNavClasses}}">
      <ng-container *ngFor="let tab of data">
        <li *ngIf="tab.show">
          <a class="sub-nav__links " [ngClass]="{'sub-nav__links--active': tab.isActive,'disabled': !tab.enabled}"
             (click)="onTabChange(tab.id)" [routerLink]="" queryParamsHandling="preserve">
            <span>{{tab.name}}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </ng-container>
  <ng-template #heading>
    <div class="page-heading">
      <h1>{{ title }}</h1>
    </div>
  </ng-template>
</ng-template>
